
import React from "react";
import { Content, Spinner, Bullseye } from "@patternfly/react-core";

export const SpinnerPage = ({ themeVersion, isLoaded, textSpinner, className }) => {
    return (
        <>
        <Bullseye key={themeVersion} style={{ height: '100vh' }} className={className}>
            <Content style={{marginLeft: '20%', margin: 'auto'}}>
                <Content style={{ContentAlign: 'center'}} component="h1">{textSpinner} ...</Content>
                {isLoaded === false
                ? <Bullseye><Spinner  size="xl" aria-label="" /></Bullseye>
                : <Bullseye className="pf-u-hidden"><Spinner size="xl" aria-label="" className="pf-u-hidden" /></Bullseye>
                }
            </Content>
        </Bullseye>
        </>
    )
}